export const CALCULATOR_DEFAULTS = {
  avgPropertyPrice: 250_000,
  avgFeePercent: 1.2,
  extraInstructionsPerYear: 3,
} as const

export const PLANS = [
  { name: "Agent", monthlyCost: 49, label: "Self-service" },
  { name: "Managed", monthlyCost: 299, label: "Recommended" },
  { name: "Fully Managed", monthlyCost: 799, label: "White glove" },
] as const

export type Plan = (typeof PLANS)[number]

export interface CalculatorInputs {
  avgPropertyPrice: number
  feePercent: number
  extraInstructions: number
  monthlyCost: number
}

export interface CalculatorResults {
  feePerInstruction: number
  annualExtraRevenue: number
  annualCost: number
  netProfit: number
  roi: number
  breakEvenInstructions: number
}

export function calculateROI(inputs: CalculatorInputs): CalculatorResults {
  const feePerInstruction = inputs.avgPropertyPrice * (inputs.feePercent / 100)
  const annualExtraRevenue = feePerInstruction * inputs.extraInstructions
  const annualCost = inputs.monthlyCost * 12
  const netProfit = annualExtraRevenue - annualCost
  const roi = annualCost > 0 ? (netProfit / annualCost) * 100 : 0
  const breakEvenInstructions =
    feePerInstruction > 0 ? annualCost / feePerInstruction : 0

  return {
    feePerInstruction,
    annualExtraRevenue,
    annualCost,
    netProfit,
    roi,
    breakEvenInstructions: Math.ceil(breakEvenInstructions * 10) / 10,
  }
}

export { formatCurrency } from "@/lib/format-currency"
